import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const initialFilters = {
  transactionTypeList: [],
  businessAreaList: [],
  transactionStartDate: "",
  transactionEndDate: "",
};

// export const fetchAllTransactions = (transactionTypeList) => {
//   switch (transactionTypeList) {
//     default:
//       return [];
//   }
// };

export const getBusinessAreasDropdown = async () => {
  const res = await fetchAllPromisedData(
    `${endpoint?.businessArea.getAllActive}`
  );

  if (res.length) {
    const options = res.map((item) => ({
      label: `${item.businessAreaDispValue}`,
      value: item.id,
      businessAreaKey: item.businessAreaKey,
    }));

    return options;
  }

  return [];
};

export const transactionType = [
  {
    label: "BRANCH_ISSUANCE",
    value: "BRANCH_ISSUANCE",
  },
  {
    label: "PSID_ISSUANCE",
    value: "PSID_ISSUANCE",
  },
  {
    label: "BRANCH_RETURN",
    value: "BRANCH_RETURN",
  },
  {
    label: "PSID_RETURN",
    value: "PSID_RETURN",
  },
  {
    label: "DLP_PSID_ISSUANCE",
    value: "DLP_PSID_ISSUANCE",
  },
  {
    label: "DLP_PSID_RETURN",
    value: "DLP_PSID_RETURN",
  },
  {
    label: "DLP_BRANCH_ISSUANCE",
    value: "DLP_BRANCH_ISSUANCE",
  },
  {
    label: "DLP_BRANCH_RETURN",
    value: "DLP_BRANCH_RETURN",
  },
  {
    label: "DLP_PSID_REVERSAL",
    value: "DLP_PSID_REVERSAL",
  },
  {
    label: "PSID_REVERSAL",
    value: "PSID_REVERSAL",
  },
  {
    label: "DIGITAL_PSID_ISSUANCE",
    value: "DIGITAL_PSID_ISSUANCE",
  },
  {
    label: "DIGITAL_PSID_RETURN",
    value: "DIGITAL_PSID_RETURN",
  },
  {
    label: "DIGITAL_BRANCH_ISSUANCE",
    value: "DIGITAL_BRANCH_ISSUANCE",
  },
  {
    label: "DIGITAL_BRANCH_RETURN",
    value: "DIGITAL_BRANCH_RETURN",
  },
  {
    label: "DIGITAL_PSID_REVERSAL",
    value: "DIGITAL_PSID_REVERSAL",
  },
];
